module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sponsors"
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-5"
  }, [_vm._m(1), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.sponsors.slice(0, 3)), function(r) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": r.src,
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v("\n              " + _vm._s(r.desc) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Media & Network Partners")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.mediaPartners.slice(0, 4)), function(r) {
    return _c('div', {
      staticClass: "column"
    }, [_c('a', {
      attrs: {
        "href": r.url
      }
    }, [_c('img', {
      attrs: {
        "src": r.src,
        "alt": r.name
      }
    }), _c('br'), _vm._v(_vm._s(r.name))]), _vm._v("\n              " + _vm._s(r.desc) + "\n            ")])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "has-text-grey-light is-size-4"
  }, [_vm._v("\n            Want to sponsor us? Your name will be known in our hackerspace & cowork. We hosted 1000+ technical and technological events so far.\n            We can give you huge marketing push or find you geeks, engineers, software developers you are searching for.\n            We are their daily place, where their come hangout on evenings or work during day.\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/eventspace/IMG_20190327_190708_vedatour.jpg",
      "alt": "progressbar coworking bratislava meetup"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("Beloved & Brave Sponsors of "), _c('a', {
    attrs: {
      "href": "https://cowork.progressbar.sk"
    }
  }, [_vm._v(" Progressbar Cowork")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec0fe1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sponsors.vue
// module id = 238
// module chunks = 14